/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { PhysicianNotificationViewModel } from './PhysicianNotificationViewModel'; 

export function getPhysicianNotificationOptions(physicianNotificationId: string, onSuccess?: (result: PhysicianNotificationViewModel) => void) {
	return queryOptions({
		queryKey: ['physician-notification', physicianNotificationId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/coordination/physiciannotifications/queries/getphysiciannotification/' + physicianNotificationId;
			const resp = await axios.get<PhysicianNotificationViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(physicianNotificationId)
	});
}